module.exports = __webpack_public_path__ + "static/media/bg.330ad968.svg";